import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { DayDetailsStyle } from './DayDetails.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import DayEvent from './DayEvent';
import { IEvent, ILocalEvent } from '@app-types/websocket/event.types';
import { IScheduleEvent } from './scheuldeEvent.types';
import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import DayScheduleEvent from './DayScheduleEvent';
// import { IPackingList } from '@containers/calendar/calendar.container';
import { ITodo, TODO_TYPE } from '@app-types/websocket/todo.types';
import DayImportedEvent from './DayImportedEvent';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';
import DayExternalEvent from './DayExternalEvent';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof DayDetailsStyle> {
  day: Date;
  reference:React.RefObject<HTMLDivElement>;
  localization: "se"|"en";
  family:IFamilyMember[];
  schoolAge:number;
  events:IEvent[];
  importedEvents:ILocalEvent[];
  externalEvents:IExternalCalenderEvent[]|undefined;
  todos:ITodo[];

  userId:number
  scheduleOne:ISchedule|undefined;
  scheduleTwo:ISchedule|undefined;
  scheduleThree:ISchedule|undefined;

  showEventDetails:(eventId:number|undefined) => void;
  showScheduleDetails:(event:IScheduleEvent|undefined, position:"START"|"END") => void;
  createEventOnDate: (day:Date) => void;
  editTodo:(todo:ITodo|undefined) => void;
  addPackingListItem:(scheduleId:number) => void;
  seenEvent: (id:number) => void;
  completedEvent : (eventId:number) => void;
  zoomImage: (url:string|undefined) => void;

  onlyWeeksOf: number | undefined;
  isParent:boolean;
  holidays?:{ [key:string]:{title:string, type:"HOLIDAY"|"SPECIAL_DAY"}; };
}

interface IState {
  someValue: number;
}

interface IDayEvent {
  time:number;
  activity?: IEvent;
  importedActivity?:ILocalEvent;
  externalEvent?:IExternalCalenderEvent;
  scheduleEvent?: IScheduleEvent;
  scheduleEventStart:boolean;
  scheduleEventEnd:boolean;
}

interface IDayData {
  events:JSX.Element[];
  barOneStart:React.CSSProperties;
  barTwoStart:React.CSSProperties; 
  barThreeStart:React.CSSProperties;
  barOneEnd:React.CSSProperties;
  barTwoEnd:React.CSSProperties; 
  barThreeEnd:React.CSSProperties;
}

class Day extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      someValue: 1,
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    return;
  }

  public componentDidMount() {
    return;
  }

  public render() {
    const {classes, day, events, scheduleOne, scheduleTwo, scheduleThree, userId, importedEvents, externalEvents} = this.props;

    const dayCopy:Date = new Date(day.getFullYear(), day.getMonth(), day.getDate(),0,0,0,0);
    const startOfDay = dayCopy.getTime();
    dayCopy.setHours(23);
    dayCopy.setMinutes(59);
    dayCopy.setSeconds(59);
    dayCopy.setMilliseconds(59);
    const endOfDay = dayCopy.getTime();

    const scheduleEvents:IScheduleEvent[] = [];

    this.filterScheduleEvents(scheduleEvents, scheduleOne, startOfDay, endOfDay, undefined,1);
    this.filterScheduleEvents(scheduleEvents, scheduleTwo, startOfDay, endOfDay, undefined,2);
    this.filterScheduleEvents(scheduleEvents, scheduleThree, startOfDay, endOfDay, undefined,3);

    const todaysActivities:IEvent[] = [];
    for (const event of events) {
      if ( (event.startTime >= startOfDay && event.endTime <= endOfDay )
        || (event.startTime <= startOfDay && event.endTime >= startOfDay )
        || (event.startTime <= endOfDay && event.endTime >= endOfDay)) {
          todaysActivities.push(event);
        }
    }

    const todaysImportedActivities:ILocalEvent[] = [];
    for (const event of importedEvents) {
      if ( (event.startTime >= startOfDay && event.endTime <= endOfDay )
        || (event.startTime <= startOfDay && event.endTime >= startOfDay )
        || (event.startTime <= endOfDay && event.endTime >= endOfDay)) {
          todaysImportedActivities.push(event);
        }
    }

    const todaysData:IDayData = this.generateTodaysEvents(scheduleEvents, todaysActivities, todaysImportedActivities, 
      externalEvents?externalEvents:[], startOfDay, endOfDay, userId);
    const now:Date = new Date();
    
    const today = (now.getDate() === day.getDate() && now.getMonth() === day.getMonth() 
      && now.getFullYear() === day.getFullYear())?(" - "+tn.lang.today):"";

    const todayString =   tn.formatDateYearMonthDay(dayCopy);
    let holiday:{title: string;type: "HOLIDAY" | "SPECIAL_DAY";}|undefined;
    if (this.props.holidays && this.props.holidays[todayString] !== undefined) {
      holiday = this.props.holidays[todayString];
    }

    return (
      <div className={classes.detailedDay}>
        <div ref={this.props.reference} 
          className={classes.dayHeader}
          id={day.getFullYear()+"-"+(day.getMonth()<10?"0":"")+(day.getMonth())+"-"+(day.getDate()<10?"0":"")+day.getDate()}>

            <div className={classes.dayTitle}>
              <div className={classes.dayDate}>
                {tn.formatMonthDate(day)} 
              </div>
              <div className={classes.dayWeekday}>
                {tn.lang.getWeekdayName(day.getDay())+today}
                <span style={(holiday && holiday.type === "HOLIDAY")?{color:"red", marginLeft: '3px'}:{marginLeft: '3px'}}>
                  {holiday && holiday.title}
                </span>
              </div>
            </div>
            <div className={classes.eventScheduleBands}>
              <div className={classes.eventScheduleBand} style={todaysData.barTwoStart}/>
              <div className={classes.eventScheduleBand} style={todaysData.barOneStart}/>
              <div className={classes.eventScheduleBand} style={todaysData.barThreeStart}/>
            </div>
        </div>

        
        {todaysData.events}

        <div className={classes.eventScheduleBands} style={{minHeight:'1px'}}>
          <div className={classes.dayLine} />
          <div className={classes.eventScheduleBands}>
            <div className={classes.eventScheduleBand} style={todaysData.barTwoEnd}/>
            <div className={classes.eventScheduleBand} style={todaysData.barOneEnd}/>
            <div className={classes.eventScheduleBand} style={todaysData.barThreeEnd}/>
          </div>
        </div>
      </div>
    );
  }
  
  private generateTodaysEvents = (scheduleEvents:IScheduleEvent[], todaysActivities:IEvent[], importedActivites:ILocalEvent[], 
    externalEvents:IExternalCalenderEvent[], startOfDay:number, endOfDay:number, userId:number):IDayData => {

    const events:IDayEvent[] = [];
    for (const se of scheduleEvents) {
      if (se.startTime < startOfDay) {
        events.push({
          time: se.startTime,
          scheduleEvent: se,
          scheduleEventStart: false,
          scheduleEventEnd: false,
        });
      }
      else if (se.startTime >= startOfDay && se.startTime <= endOfDay) {
        events.push({
          time: se.startTime,
          scheduleEvent: se,
          scheduleEventStart: true,
          scheduleEventEnd: false,
        });
      }
      if (se.endTime >= startOfDay && se.endTime <= endOfDay) {
        events.push({
          time: se.endTime,
          scheduleEvent: se,
          scheduleEventStart: false,
          scheduleEventEnd: true,
        });
      }
    }

    for (const te of todaysActivities) {
      events.push({
        time: te.startTime,
        activity: te,
        scheduleEventStart: false,
        scheduleEventEnd: false,
      });
    }

    for (const ie of importedActivites) {
      events.push({
        time: ie.startTime,
        activity: undefined,
        importedActivity:ie,
        scheduleEventStart: false,
        scheduleEventEnd: false,
      });
    }

    for (const ie of externalEvents) {
      events.push({
        time: ie.startTime,
        activity: undefined,
        importedActivity:undefined,
        externalEvent:ie,
        scheduleEventStart: false,
        scheduleEventEnd: false,
      });
    }

    events.sort((a,b) => {
      if (a.time === b.time) {
        if (a.activity !== undefined && b.activity !== undefined) {
          return b.activity.id - a.activity.id;
        } else if (a.scheduleEvent !== undefined && b.scheduleEvent !== undefined) {
          if (a.scheduleEventEnd && b.scheduleEventStart) {
            return -1;
          } else if (b.scheduleEventEnd && a.scheduleEventStart) {
            return 1;
          }
          return b.scheduleEvent.schedule.id - a.scheduleEvent.schedule.id
        } else if (a.scheduleEvent !== undefined) {
          return -1;
        } else if (b.scheduleEvent !== undefined) {
          return 1;
        } else {
          return 0;
        }
      } else {
        if (a.time < startOfDay && b.time < startOfDay) {
          if (a.scheduleEvent !== undefined && b.scheduleEvent !== undefined) {
            return b.scheduleEvent.schedule.id - a.scheduleEvent.schedule.id
          } else if (a.scheduleEvent !== undefined) {
            return -1;
          } else if (b.scheduleEvent !== undefined) {
            return 1;
          } else if (a.activity !== undefined && b.activity !== undefined) {
            return b.activity.id - a.activity.id;
          }
          return 0;
        }
        return a.time - b.time;
      }
    })

    const renderedEvents:JSX.Element[] = [];
    let barOneStart:React.CSSProperties = {backgroundColor: "#ffffff00"};
    let barTwoStart:React.CSSProperties = {backgroundColor:"#ffffff00"};
    let barThreeStart:React.CSSProperties = {backgroundColor:"#ffffff00"};

    let barOne:React.CSSProperties = {backgroundColor:"#ffffff00"};
    let barTwo:React.CSSProperties = {backgroundColor:"#ffffff00"};
    let barThree:React.CSSProperties = {backgroundColor:"#ffffff00"};

    for (const event of events) {
      if (event.activity !== undefined) {
        renderedEvents.push(<DayEvent showDetails={this.props.showEventDetails} 
          zoomImage={this.props.zoomImage}
          key={"a"+event.activity.id} event={event.activity} userId={userId} seenEvent={this.props.seenEvent}
          localization={this.props.localization} family={this.props.family} renderForDate={this.props.day} 
          barOneBackground={barOne} barTwoBackground={barTwo} barThreeBackground={barThree} completedBy={this.props.completedEvent}/>)
      } else if (event.externalEvent !== undefined) {
        renderedEvents.push(<DayExternalEvent userId={userId} 
          key={"ev"+event.externalEvent.id} event={event.externalEvent} family={this.props.family}
          localization={this.props.localization} renderForDate={this.props.day} 
          barOneBackground={barOne} barTwoBackground={barTwo} barThreeBackground={barThree}/>)
      } else if (event.importedActivity !== undefined) {
        renderedEvents.push(<DayImportedEvent
          key={"ie"+event.importedActivity.id} event={event.importedActivity} 
          localization={this.props.localization} renderForDate={this.props.day} 
          barOneBackground={barOne} barTwoBackground={barTwo} barThreeBackground={barThree}/>)
      } else if (event.scheduleEvent !== undefined) {
        if (event.scheduleEventEnd) {

          /*
          if (event.scheduleEvent.schedulePosition === 1) {barOne = "#ffffff00";}
          else if (event.scheduleEvent.schedulePosition === 2) {barTwo = "#ffffff00";}
          else if (event.scheduleEvent.schedulePosition === 3) {barThree = "#ffffff00";}
*/

          renderedEvents.push(<DayScheduleEvent key={"s"+event.scheduleEvent.schedule.id+event.scheduleEvent.eventId} event={event.scheduleEvent} 
            family={this.props.family} type={"end"} userId={userId} addPackingListItem={(id) => this.props.addPackingListItem(id)}
            hideThis={event.scheduleEvent.hideThis} schoolAge={this.props.schoolAge}
            showDetails={() => this.props.showScheduleDetails(event.scheduleEvent, "END")} editTodo={(todo) => this.props.editTodo(todo)}
            barOneBackground={barOne} barTwoBackground={barTwo} barThreeBackground={barThree} />);
        } else {
          if (event.scheduleEvent.schedulePosition === 1) {barOne = {backgroundColor:event.scheduleEvent.parentColor, flex: 1};}
          else if (event.scheduleEvent.schedulePosition === 2) {barTwo = {backgroundColor:event.scheduleEvent.parentColor, flex: 1};}
          else if (event.scheduleEvent.schedulePosition === 3) {barThree = {backgroundColor:event.scheduleEvent.parentColor, flex: 1};}

          if (event.scheduleEventStart) {
            renderedEvents.push(<DayScheduleEvent key={"e"+event.scheduleEvent.schedule.id+event.scheduleEvent.eventId} event={event.scheduleEvent} 
              family={this.props.family} type={"start"} userId={userId} addPackingListItem={(id) => this.props.addPackingListItem(id)}
              hideThis={event.scheduleEvent.hideThis} schoolAge={this.props.schoolAge}
              showDetails={() => this.props.showScheduleDetails(event.scheduleEvent, "START")} editTodo={(todo) => this.props.editTodo(todo)}
              barOneBackground={barOne} barTwoBackground={barTwo} barThreeBackground={barThree} />);
          }
        }
      }
      if (event.time < startOfDay) {
        barOneStart = barOne;
        barTwoStart = barTwo;
        barThreeStart = barThree;
      }
    }

    return {events:renderedEvents, barOneStart, barTwoStart, barThreeStart, barOneEnd:barOne, barTwoEnd: barTwo, barThreeEnd:barThree};
  }

  private filterScheduleEvents = (result:IScheduleEvent[], schedule:ISchedule|undefined, startOfDay:number, 
    endOfDay:number, parentId:number|undefined, schedulePosition:1|2|3) => {
    

    if (schedule && schedule.data) {
      const children:number[] = schedule.data.children;
      if (parentId === undefined || schedule.data.parentA === parentId) {
        const pId = schedule.data.parentA;
        let parentColor = "#cccccc";
        let hideThis:boolean = false;
        if (this.props.onlyWeeksOf !== undefined) {
          if (pId === this.props.onlyWeeksOf) {
            // A parent's own weeks take the children's colour; a chosen parent keeps theirs.
            if (pId === this.props.userId && schedule.data.children.length > 0 ) {
              const kid = this.props.family.find((mem) => mem.id === schedule.data.children[0]);
              parentColor = kid?kid.color:"#cccccc";
            } else {
              const parent = this.props.family.find((mem) => mem.id === pId);
              parentColor = parent?parent.color:"#cccccc";
            }
          } else {
            parentColor = "#cccccc00";
            hideThis = true;
          }
        } else {
          const parent = this.props.family.find((mem) => mem.id === pId);
          parentColor = parent?parent.color:"#cccccc";  
        }
        this.addScheduleEvents(result,schedule.data.scheduleEntriesParentA,startOfDay,endOfDay, 
          pId, parentColor, children, schedule, schedulePosition, hideThis);
      }
      if (parentId === undefined || schedule.data.parentB === parentId) {
        const pId = schedule.data.parentB;
        let parentColor = "#cccccc";
        let hideThis:boolean = false;
        if (this.props.onlyWeeksOf !== undefined) {
          if (pId === this.props.onlyWeeksOf) {
            // A parent's own weeks take the children's colour; a chosen parent keeps theirs.
            if (pId === this.props.userId && schedule.data.children.length > 0 ) {
              const kid = this.props.family.find((mem) => mem.id === schedule.data.children[0]);
              parentColor = kid?kid.color:"#cccccc";
            } else {
              const parent = this.props.family.find((mem) => mem.id === pId);
              parentColor = parent?parent.color:"#cccccc";
            }
          } else {
            parentColor = "#cccccc00";
            hideThis = true;
          }
        } else {
          const parent = this.props.family.find((mem) => mem.id === pId);
          parentColor = parent?parent.color:"#cccccc";  
        }
        this.addScheduleEvents(result,schedule.data.scheduleEntriesParentB,startOfDay,endOfDay, 
          pId, parentColor, children, schedule, schedulePosition, hideThis);
      }
    }
    
    return result;
  }

  private addScheduleEvents = (events:IScheduleEvent[], schedule:{[key: string]: IScheduleEntry;}, startOfDay:number, 
    endOfDay:number, parent:number, parentColor:string, children:number[], scheduleObject:ISchedule, schedulePosition:1|2|3,
    hideThis:boolean) => {
    
    const now = new Date();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    now.setMilliseconds(0);

    const todayStartOfDay = now.getTime();

    now.setHours(23);
    now.setMinutes(59);
    now.setSeconds(59);
    now.setMilliseconds(999);

    const todayEndOfDay = now.getTime();


    for (const key of Object.keys(schedule)) { 
      const scheduleEntry: IScheduleEntry = schedule[key];
      if ( (scheduleEntry.startTime >= startOfDay && scheduleEntry.endTime <= endOfDay )
      || (scheduleEntry.startTime <= startOfDay && scheduleEntry.endTime >= startOfDay )
      || (scheduleEntry.startTime <= endOfDay && scheduleEntry.endTime >= endOfDay)) {

        let packingListStatus:"passed"|"current"|"future"|"dayhandover"|"generate" = "passed";
        let todos:ITodo[] = [];

        if (scheduleEntry.startTime >= startOfDay && scheduleEntry.endTime <= endOfDay) { // no packinglists for day visits
          packingListStatus = "dayhandover";
        } else if (scheduleEntry.endTime > todayStartOfDay && scheduleEntry.startTime < todayEndOfDay) { // the schedule entry is spanning today
          packingListStatus = "current";
          if (scheduleEntry.endTime > startOfDay && scheduleEntry.endTime < endOfDay) { // the schedule entry end on the day we are generating for
            if (scheduleObject.lastHandover < scheduleEntry.startTime) { // no packing list has been generated for this handover yet
              packingListStatus = "generate";
            } else {
              todos=this.props.todos.filter((todo) => (todo.type === TODO_TYPE.HANDOVER && scheduleObject.id === todo.scheduleId) 
              && ((todo.handovergroup === undefined && scheduleObject.lastHandover < scheduleEntry.endTime))
              && (todo.hidden === undefined || todo.hidden.length === 0)
                || ((todo.handovergroup !== undefined && todo.handovergroup > startOfDay && todo.handovergroup < endOfDay)));
            }
          }
        } else if (scheduleEntry.endTime < todayStartOfDay) {
          packingListStatus = "passed"; 
        } else if (scheduleEntry.startTime > todayEndOfDay) {
          packingListStatus = "future";
        }


        events.push({
          startAtSchool: scheduleEntry.startAtSchool,
          endAtSchool: scheduleEntry.endAtSchool,
          eventId: scheduleEntry.id,
          schedule: scheduleObject,
          children,
          parent,
          startTime: scheduleEntry.startTime,
          endTime: scheduleEntry.endTime,
          startLoc: scheduleEntry.startLoc,
          endLoc: scheduleEntry.endLoc,
          parentColor,
          schedulePosition,
          packingListStatus,
          packingList:todos,
          hideThis:(hideThis && todos.length === 0),
        });
      }
    }
  }

}

export default withStyles(DayDetailsStyle)(Day);



// WEBPACK FOOTER //
// ./src/components/calendar2/dayDetails/Day.tsx